import { useCallback, useEffect, useState } from 'react';
import Panel from './Panel.jsx';
import { getDealModels, getFamilies } from '@/services/aircraft-identity.service.js';
import PlaceModel from '@/components/aircraft/PlaceModel.jsx';
import { StateTailModel, ConfirmTailModel } from '@/components/aircraft/StateTailModel.jsx';

// THE DEAL'S AIRCRAFT QUESTIONS (MAKE-MODEL-TIME-SPEC sections 1 and 3): an aircraft on this deal whose model has no
// family asks David to place it (nothing defaults); an aircraft whose model is still open asks for the data plate; an
// applicant's data plate answer asks for his confirmation. Shown only while a question is open.
export default function DealModelsPanel({ dealId, refreshKey }) {
  const [data, setData] = useState(null);
  const [families, setFamilies] = useState([]);
  const [err, setErr] = useState(null);
  const load = useCallback(() => {
    if (!dealId) return;
    Promise.all([getDealModels(dealId), getFamilies()])
      .then(([d, f]) => { setData(d); setFamilies(f.families || []); setErr(null); })
      .catch((e) => setErr(e?.body?.error || e?.message || 'could not read'));
  }, [dealId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  if (err) return <Panel title="Aircraft models"><p className="px-4 py-3 text-[13px] text-danger">The aircraft identity could not be read: {err}</p></Panel>;
  const open = (data?.aircraft || []).filter((a) => a.question);
  if (!open.length) return null;
  return (
    <Panel title="Aircraft models" count={open.length}>
      <p className="px-4 pt-3 text-[12.5px] text-text-muted">Each aircraft's make and model, and the family its time is asked by on the pilot form.</p>
      <ul className="divide-y divide-border">
        {open.map((a) => (
          <li key={a.tail} className="space-y-2 px-4 py-3 text-[13px] text-text">
            {a.question === 'place_model' ? (
              <>
                <div><span className="font-medium">{a.tail}</span> is {a.label}. Which family does its time count in?</div>
                <PlaceModel model={{ model_key: a.model_key, label: a.label }} families={families} onPlaced={load} />
              </>
            ) : a.question === 'confirm_answer' ? (
              <>
                <div><span className="font-medium">{a.tail}</span>: the applicant read the data plate as {a.applicant_answer?.label}.</div>
                <ConfirmTailModel tail={a.tail} answer={a.applicant_answer} onDone={load} />
              </>
            ) : (
              <>
                <div><span className="font-medium">{a.tail}</span>: {a.words}. {a.candidates.length ? 'Which one is it?' : 'What does the plate say?'}</div>
                <StateTailModel tail={a.tail} candidates={a.candidates} onDone={load} />
              </>
            )}
          </li>
        ))}
      </ul>
    </Panel>
  );
}
